import { InvalidEngagementStateStrategy } from './invalid-engaement-state-strategy.model';

export class PaymentMethodNoLongerRequiredStrategyModel extends InvalidEngagementStateStrategy {

  constructor(hasAdditionalTasks: boolean, engagementId: number) {
    super(engagementId, hasAdditionalTasks);
  }

  getTitle() {
    return 'Sorry, your engagement tasks are out of date.';
  }
  getMessage(): string {
    return 'Reload to see the latest version and try again.';
  }

  getImagePath() {
    return 'already-signed.png';
  }
}
